export default function initMainNav() {
  const body = document.body;
  const header = document.querySelector(".header");
  const navActiveClass = "nav-active";
  const dropActiveClass = "drop-active";
  const hasDropClass = "has-drop";
  const navBar = header?.querySelector(".navbar");

  if (!navBar) return;

  const navOpener = navBar.querySelector(".nav-opener");
  const dropDowns = navBar.querySelectorAll(".subnav");
  const dropOpeners = navBar.querySelectorAll(".subnav-opener");

  const updateSubnavHeight = () => {
    dropDowns.forEach((elm) => {
      const height = elm.querySelector(".sub-holder").clientHeight;
      elm.closest("li").classList.add(hasDropClass);
      elm.style.setProperty("--height", `${parseInt(height) + 40}px`);
    });
  };
  updateSubnavHeight();
  window.addEventListener("resize", updateSubnavHeight);

  const handleHideMenu = () => {
    const openedElem = navBar.querySelector(`.${dropActiveClass}`);
    openedElem?.classList.remove(dropActiveClass);
    body.classList.remove(navActiveClass);
  };

  const handleShowMenu = () => {
    body.classList.add(navActiveClass);
  };

  const handleTabKey = (e) => {
    const activeDrop = document.querySelector(`.${dropActiveClass}`);
    if (e.key === "Tab" && activeDrop && !activeDrop.contains(e.target)) {
      handleHideMenu();
    }
  };

  navOpener?.addEventListener("click", (e) => {
    e.preventDefault();
    if (body.classList.contains(navActiveClass)) {
      handleHideMenu();
    } else {
      handleShowMenu();
    }
  });

  window.addEventListener("click", (e) => {
    if (!navBar.contains(e.target) && !navOpener.contains(e.target)) {
      if (body.classList.contains(navActiveClass)) {
        handleHideMenu();
      }
      }
      const activeDrop = document.querySelector(`.${dropActiveClass}`);
      if (!activeDrop) return;
      if (!activeDrop.querySelector('.subnav-opener').contains(e.target) && !activeDrop.querySelector('.subnav-inner').contains(e.target)) {
          activeDrop.classList.remove(dropActiveClass);
      }
  });

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      handleHideMenu();
      const activeDrop = document.querySelector(`.${dropActiveClass}`);
      if (activeDrop) {
        handleHideDrop(activeDrop.querySelector(".subnav-opener"));
      }
    } else if (e.key === "Tab") {
      handleTabKey(e);
    }
  });

  const handleHideDrop = (elm) => {
    elm?.closest("li").classList.remove(dropActiveClass);
  };

  const handleShowDrop = (elm) => {
    const openedElem = navBar?.querySelector(`.${dropActiveClass}`);
    openedElem?.classList.remove(dropActiveClass);
    elm?.closest("li").classList.add(dropActiveClass);
  };

  dropOpeners.forEach((elm) => {
    elm.addEventListener("click", (e) => {
      e.preventDefault();
      if (elm.closest("li").classList.contains(dropActiveClass)) {
        handleHideDrop(elm);
      } else {
        handleShowDrop(elm);
      }
    });
  });

  dropDowns.forEach((elm) => {
    const height = elm.querySelector(".sub-holder").clientHeight;
    elm.closest("li").classList.add(hasDropClass);
    elm.style.setProperty("--height", `${parseInt(height) + 40}px`);
  });
}